export function removeTemplateFromString(text: string): string {
  if (!text) {
    return "";
  }

  return text.replace(/template/gi, "").trim();
}
